import React from "react";
import { PlanDropdownContextProvider } from "../components/PlanDropdown/utils/PlanDropdownContext";
import { RebookingFormContextProvider } from "../components/RenewBookingForm/utils/RenewBookingFormContext";
import { IEventModule } from "./IEventModule";
import { OldEventPageTemplate } from "./OldEventPageTemplate";
import { useFetchVariants } from "../components/VariantSelector/utils/useFetchVariants";
import { BonusOfferingContextProvider } from "../components/RenewBookingForm/utils/BonusOfferingContext";
import { InstalmentsDetailsContextProvider } from "../components/PaymentPlan/utils/InstalmentsDetailsContext";

/**
 * Calling this "old" cause, the way data flow in this is confusing.
 * This flow should not be carried to future implementations.
 * Aim should be to simplify this one as much as possible,
 * so that one day its not a pain in the ass for a new dev to understand the data flow.
 */
const OldEventPageTemplateContextProvider = (props: IEventModule.IProps) => {
    const { urlQueryParams, hideSelf } = props;
    useFetchVariants();
    const isOpenedAsEventModal = !!hideSelf;
    const baseComponent = <OldEventPageTemplate {...props} />;
    const withRebookingFormContext = (
        <RebookingFormContextProvider urlQueryParams={urlQueryParams}>
            {baseComponent}
        </RebookingFormContextProvider>
    );

    const withPlanDropdownContext = (
        <PlanDropdownContextProvider
            urlQueryParams={urlQueryParams}
            isOpenedAsEventModal={isOpenedAsEventModal}
        >
            {withRebookingFormContext}
        </PlanDropdownContextProvider>
    );

    const withBonusOfferingContext = (
        <BonusOfferingContextProvider>
            {withPlanDropdownContext}
        </BonusOfferingContextProvider>
    );

    const withInstalmentsDetailsContext = (
        <InstalmentsDetailsContextProvider>
            {withBonusOfferingContext}
        </InstalmentsDetailsContextProvider>
    );

    const finalComponent = withInstalmentsDetailsContext;

    return finalComponent;
};

export default OldEventPageTemplateContextProvider;
